import React from 'react';
import { SvgIcon } from '@mui/material';

const CopyUrlIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 292.973 277.732"
      enableBackground="new 0 0 292.973 277.732"
      xmlSpace="preserve"
    >
      <g id="Link">
        <path d="M230.66,221c0,0,11-1,11,11s-11,12-11,12h-79.33c0,0-10,0.667-10-11s10-12,10-12H230.66z" />
        <path d="M286.967,196.802c-5.42-6.654-13.237-8.135-21.278-8.135c-14.237,0-28.474,0-42.71,0c-7.865,0-14.37,1.076-20.8,6.313
		c-4.927,4.013-6.493,9.787-6.974,15.691c0,0,71.83-0.005,74.077-0.005c1.019,0,1.223,0.125,1.223,1.462c0,14.401,0,27.803,0,42.205
		c-0.036,0.665-0.278,1-1.223,1c-1.797,0-74.144-0.005-74.144-0.005c0.547,6.321,2.819,12.253,7.994,16.468
		c5.587,4.551,11.79,5.537,18.681,5.537c12.57,0,25.141,0,37.711,0c3.319,0,6.638,0,9.956,0c12.09,0,21.023-9.101,22.755-20.417
		c0.173-0.802,0.271-1.661,0.271-2.583c0-12.404,0-23.808,0-36.212C292.504,210.319,292.239,203.273,286.967,196.802z"
        />
        <path d="M178.248,210.672c-0.46-4.919-1.741-9.524-5.281-13.87c-5.42-6.654-13.237-8.135-21.278-8.135c-14.237,0-28.474,0-42.71,0
		c-7.865,0-14.37,1.076-20.8,6.313c-6.616,5.389-7.182,13.954-7.182,21.748c0,12.13,0,23.261,0,35.391
		c0,7.492,2.091,14.754,8.135,19.677c5.587,4.551,11.79,5.537,18.681,5.537c12.57,0,25.141,0,37.711,0c3.319,0,6.638,0,9.956,0
		c12.09,0,21.023-9.101,22.755-20.417c0.109-0.504,0.175-1.039,0.218-1.589c0,0-73.361,0.005-74.456,0.005c-0.716,0-1-0.174-1-1.462
		c0-13.133,0-25.266,0-38.399c0-1.269,0-2.537,0-3.806c0-0.702,0.209-1,1.393-1L178.248,210.672z"
        />
      </g>
      <g id="World_grid">
        <path d="M56.663,81.667c44.875,0,89.751,0,134.627,0c0.013,0,0.026,0,0.04,0c7.738,0,7.738-12,0-12c-44.875,0-89.751,0-134.627,0
		c-0.013,0-0.026,0-0.04,0C48.925,69.667,48.925,81.667,56.663,81.667L56.663,81.667z"
        />
        <path d="M20.33,132c48.788,0,97.575,0,146.363,0c20.324,0,40.647,0,60.971,0c7.738,0,7.738-12,0-12c-48.788,0-97.575,0-146.363,0
		c-20.324,0-40.647,0-60.971,0C12.591,120,12.591,132,20.33,132L20.33,132z"
        />
        <g>
          <path d="M80.279,108c1.157-13.09,3.56-25.999,7.739-38.3c-3.87,0-7.74,0-11.61,0C72.566,82.05,70.33,94.95,69.25,108
			C72.926,108,76.603,108,80.279,108z"
          />
          <path d="M79.556,120c-3.662,0-7.323,0-10.985,0c-0.502,15.978,0.514,31.997,2.259,47.333c0.792,6.964,11.801,7.042,11,0
			C80.083,151.981,79.02,135.952,79.556,120z"
          />
          <path d="M92.763,57.7c0.966-2.116,1.989-4.21,3.082-6.276c4.755-8.988,10.583-16.896,18.171-23.671
			c0.604-0.539,1.223-1.061,1.845-1.577c1.36-1.129,0.32-0.299,1.352-1.071c1.235-0.924,2.515-1.787,3.824-2.601
			c1.033-0.642,2.097-1.233,3.185-1.778c0.368-0.184,0.589-0.3,0.726-0.375c0.083-0.021,0.235-0.068,0.511-0.166
			c6.644-2.34,3.784-12.97-2.924-10.607c-15.892,5.599-28.047,21.432-35.803,35.581c-2.237,4.08-4.216,8.27-5.985,12.542
			C84.752,57.7,88.757,57.7,92.763,57.7z"
          />
        </g>
        <g>
          <path d="M168.819,120c0.512,16.003-0.582,32.063-2.318,47.333c-0.801,7.042,10.208,6.964,11,0
			c1.754-15.417,2.743-31.408,2.215-47.333C176.084,120,172.452,120,168.819,120z"
          />
          <path d="M179.017,108c-1.103-13.038-3.358-25.923-7.2-38.3c-3.804,0-7.608,0-11.413,0c4.19,12.268,6.577,25.192,7.712,38.3
			C171.75,108,175.384,108,179.017,108z"
          />
          <path d="M122.872,20.185c0.206,0.072,0.346,0.119,0.443,0.149c0.119,0.062,0.296,0.15,0.562,0.278
			c1.071,0.514,2.107,1.102,3.125,1.713c3.52,2.116,4.616,3.055,7.313,5.427c7.645,6.727,13.356,14.731,18.171,23.671
			c1.111,2.063,2.15,4.158,3.13,6.276c3.963,0,7.926,0,11.889,0c-1.749-4.264-3.703-8.453-5.905-12.542
			c-7.626-14.16-19.984-30.008-35.803-35.581C119.088,7.214,116.229,17.844,122.872,20.185z"
          />
        </g>
        <g>
          <path d="M117.997,120c0,14.307,0,28.614,0,42.921c0,1.471,0,2.942,0,4.413c0,7.738,12,7.738,12,0c0-15.778,0-31.556,0-47.333
			C125.997,120,121.997,120,117.997,120z"
          />
          <path d="M129.997,108c0-12.767,0-25.533,0-38.3c-4,0-8,0-12,0c0,12.767,0,25.533,0,38.3C121.997,108,125.997,108,129.997,108z" />
          <path d="M129.997,57.7c0-12.421,0-24.842,0-37.264c0-1.852,0-3.704,0-5.556c0-7.738-12-7.738-12,0c0,14.273,0,28.546,0,42.819
			C121.997,57.7,125.997,57.7,129.997,57.7z"
          />
        </g>
        <g>
          <g>
            <path d="M61.904,204.14c-37.26-28.753-48.85-81.779-29.395-122.929C51.37,41.317,93.237,19.006,136.848,23.57
				c28.427,2.975,55.542,20.313,71.499,43.932c18.993,28.113,22.241,63.421,9.73,95.447c-2.185,5.593,2.354,12.065,7.683,13.531
				c6.236,1.715,11.352-2.103,13.531-7.683c18.629-47.688,4.856-103.395-33.481-137.142C169.14-0.622,116.938-7.406,72.63,12.271
				C36.144,28.476,9.364,64.145,2.825,103.335c-7.697,46.127,11.221,91.438,47.976,119.801c4.76,3.674,12.311,0.729,15.05-3.946
				C69.174,213.516,66.641,207.795,61.904,204.14L61.904,204.14z"
            />
          </g>
        </g>
      </g>
    </svg>

  </SvgIcon>
);

export default CopyUrlIcon;
